import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'antd';
import '../resourcePool.css'
import {getByPath, getPictureInfosByPath} from "../../../../actions/storageList";

export default class Picture extends Component {
    static defaultProps = {
        checked: false,
        title: 'fdfdfdfdfdfdfdfdfdfssssssss',
        type: 'list',
        createTime: '2020-12-22 16:10:11',
        img: "/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality",
        singleClick: () => {

        },
        doubleClick: () => {

        }
    };
    static propTypes = {
        title: PropTypes.string.isRequired,//传入dom 结构
        type: PropTypes.string.isRequired,//small  middle, big ,list
        checked: PropTypes.bool,//是否选中
        doubleClick: PropTypes.func.isRequired,//双击函数
        singleClick: PropTypes.func.isRequired,//单击回调函数
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    handleEnter() {
        this.setState({hover: true})
    }

    handleOut() {
        this.setState({hover: false})
    }

    render() {
        // 鼠标点击划过  公共
        let backgroundColor
        if (this.props.checked) {
            backgroundColor = '#b5d1f4'
        } else {
            backgroundColor = '#ffffff';
            if (this.state.hover) {
                backgroundColor = '#f1f5fa';
            } else {
                backgroundColor = 'white';
            }
        }
        return (
            <div style={{cursor: 'pointer'}} onClick={() => {
                this.props.singleClick && this.props.singleClick()
            }} onDoubleClick={() => {
                this.props.doubleClick && this.props.doubleClick()
            }}>
                {this.props.type === 'list' ? this.renderFileList(backgroundColor) : this.renderFileCard(backgroundColor)}
            </div>)

    }

    //渲染小 中，大
    renderFileCard(backgroundColor) {
        let width, height, picW, picH, fontsize;
        if (this.props.type === 'small') {
            width = 140;
            height = 140;
            picW = 56;
            picH = 56;
        } else if (this.props.type === 'middle') {
            width = 200;
            height = 200;
            picW = 100;
            picH = 100;
            fontsize = 18
        } else if (this.props.type === 'big') {
            width = 300;
            height = 300;
            picW = 150;
            picH = 150;
            fontsize = 25
        }
        return (
            <div style={{
                width: width,
                height: height,
                textAlign: 'center',
                paddingTop: 11,
                background: backgroundColor,
                borderRadius: '16px',
                margin: '9px 18px 0',
                float: 'left'
            }}
                 onMouseEnter={() => this.handleEnter()}
                 onMouseLeave={() => this.handleOut()}
            >
                <img src={this.props.img} style={{width: picW, height: picH, objectFit: 'cover'}}/>
                <div title={this.props.title} className={'theretext'} style={{
                    fontSize: fontsize,
                    padding: '0 10px',
                }}>{this.props.title}</div>
            </div>
        )
    }

    //渲染列表
    renderFileList(backgroundColor) {
        return (
            <div style={{padding: '8px'}}>
                <Row style={{lineHeight: '50px', height: '50px', background: backgroundColor, borderRadius: '8px',clear: 'both'
                }}
                     onMouseEnter={() => this.handleEnter()}
                     onMouseLeave={() => this.handleOut()}>
                    <Col span={8} style={{paddingLeft: '15px'}}>
                        <div style={{display: 'flex'}}>
                            <img src={this.props.img}
                                 style={{width: '40px', height: '40px', objectFit: 'cover', paddingTop: '5px'}}/>
                            <div style={{
                                paddingLeft: '15px',
                                width: '200px',
                                height: '50px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }} title={this.props.title}>{this.props.title}</div>
                        </div>
                    </Col>
                    <Col span={8}>创建时间: {this.props.createTime}</Col>
                    <Col span={8}>图片</Col>
                </Row>
            </div>)
    }
}
// class Picture extends Resource{
// 	handleDoubleClick = ()=>{
//
// 	};
//
// 	renderShowPic(){
// 		return <img src={this.props.url.smallUrl} width={FILE_PROPERTY.showPic[this.state.showType]} height={FILE_PROPERTY.showPic[this.state.showType]} style={{objectFit:"cover"}} />;
// 	}
//
// 	renderFileType(){
// 		return "图片"
// 	}
// }